import { render } from "./Dice.vue?vue&type=template&id=ef88152e"
import script from "./Dice.vue?vue&type=script&lang=js"
export * from "./Dice.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__